import React from 'react';
import { routes } from '../routes';

const Footer = ({ onNavigate }) => {
  return (
    <footer className="bg-[#5A61E5] text-white mt-16">
      {/* Contenido principal del footer */}
      <div className="container mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
        {/* Logo */}
        <div>
          <img
            src="https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//logo%20blanco.png"
            alt="El Ancla CR"
            className="w-28"
          />
        </div>

        {/* Categorías */}
       

        {/* Soporte */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Políticas</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a onClick={() => onNavigate(routes.privacy)} className="hover:underline cursor-pointer">Política de Privacidad</a>
            </li>
            <li>
              <a onClick={() => onNavigate(routes.warranty)} className="hover:underline cursor-pointer">Política de Garantía</a>
            </li>
          </ul>
        </div>

        {/* Contacto */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Contacto</h4>
          <p className="text-sm">
            WhatsApp: <a href="https://wa.me/50689422525" target="_blank" rel="noreferrer" className="hover:underline">+506 8942 2525</a>
          </p>
          <p className="text-sm">
            Correo: <a href="mailto:info@elanclacr.com" className="hover:underline">info@elanclacr.com</a>
          </p>
        </div>

        {/* Redes sociales */}
        <div>
          <h4 className="text-lg font-semibold mb-4">Síguenos</h4>
          <div className="flex space-x-4">
            {['facebook', 'instagram', 'tiktok'].map((social) => (
              <a
                key={social}
                href={`https://www.${social}.com/elanclacr.store`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={`https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//${social}.png`}
                  alt={social}
                  className="w-6 h-6"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Métodos de pago */}
      <div className="border-t border-white border-opacity-20 py-6 px-6 flex flex-col items-center">
        <p className="text-sm mb-4">Métodos de pago</p>
        <div className="flex justify-center gap-4 flex-wrap">
          {['visa', 'mastercard', 'emma', 'sinpe'].map((method) => (
            <img
              key={method}
              src={`https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets//${method}.png`}
              alt={method}
              className="h-6 md:h-8"
            />
          ))}
        </div>
      </div>

      {/* Firma */}
      <div className="border-t border-white border-opacity-20 py-4 px-6 flex flex-col md:flex-row justify-between items-center text-sm">
        <div className="mb-2 md:mb-0 text-center md:text-left">
          © {new Date().getFullYear()} El Ancla CR. Todos los derechos reservados.
        </div>
        <div className="text-center md:text-right">
          Sitio web desarrollado por El Ancla CR
        </div>
      </div>
    </footer>
  );
};

export default Footer;
